/* eslint-disable import/no-webpack-loader-syntax */
import { useSelector } from "react-redux";
import { CookiesProvider } from "react-cookie";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Login from "./components/login";
import MainScreen from "./components/mainScreen";
import { MsalProvider } from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/App.scss";

export const queryClient = new QueryClient();
const darkTheme = createTheme({
  palette: {
    mode: "dark"
  }
});

function App({ instance }) {
  const tenant = useSelector((state) => state.user.tenant);

  return (
    <MsalProvider instance={instance}>
      <CookiesProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <div className="App" id="app">
              {tenant ? <MainScreen /> : <Login />}
            </div>
          </ThemeProvider>
        </QueryClientProvider>
      </CookiesProvider>
    </MsalProvider>
  );
}

export default App;
